var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatUnmute = function SvgChatUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8BACFF",
    d: "M22.01 0H2C.9 0 0 .9 0 2v14.42c0 1.1.9 2 2 2h12.886l1.2 1.55h.01l3.442 3.94c.16.18.46.07.46-.17v-5.32H22c1.1 0 2.001-.9 2.001-2V2c.01-1.1-.89-2-1.99-2Z"
  })));
};
export default SvgChatUnmute;